import React, { FC } from 'react';
import { useVitalMetric } from '@funtech-int/yango-shared';

import { playerMovieFirstFrame } from '@/scenarios/player/lib/metrics';

import { ContentPlayerOwnProps } from '../../../containers/ContentPlayer/ContentPlayer.types';
import { Player } from '../../Player/Player';
import { FilmPlayer } from '../../feature-player/ui/film/film-player/FilmPlayer';
import { useFilmConcurrencyArbiterConfig } from '../hooks/use-film-concurrency-arbiter-config';
import { useFilmHandlers } from '../hooks/use-film-handlers';
import { useFilmStreams } from '../hooks/use-film-streams';
import { useEmptyStreamsGuard } from '../../feature-player/hooks/player-instance/use-empty-streams-guard';

interface FilmPlayerContainerProps extends ContentPlayerOwnProps {
    contentId: string;
}

export const FilmPlayerContainer: FC<FilmPlayerContainerProps> = ({ contentId, onClose }) => {
    const { handleClose, handleWatchedTimeChange } = useFilmHandlers({ onClose });
    const firstFrameDuration = useVitalMetric(playerMovieFirstFrame);

    useEmptyStreamsGuard(useFilmStreams(contentId));

    const concurrencyArbiterConfig = useFilmConcurrencyArbiterConfig(contentId ?? '');

    return (
        <Player
            onClose={handleClose}
            contentId={contentId}
            onBeforeInit={firstFrameDuration.begin}
            onStart={firstFrameDuration.end}
            renderPlayer={({
                contentId,
                onStartCallback,
                handleError,
                handleFinish,
                psid,
                onClose,
            }) => (
                <FilmPlayer
                    contentId={contentId}
                    concurrencyArbiterConfig={concurrencyArbiterConfig}
                    onContentImpression={onStartCallback}
                    onFinish={handleFinish}
                    onError={handleError}
                    onClose={onClose}
                    psid={psid}
                    onWatchedTimeChanged={handleWatchedTimeChange}
                />
            )}
        />
    );
};
